import { graphql } from "../gql";

// export const SwappedTeacherInfoFragment = graphql(`
//   fragment SwappedTeacherInfo on SwappedTeacherInfo {
//     id
//     email
//     givenName
//     familyName
//     lesson1on1
//   }
// `);
//
// export const SuccessfulSubstitutionFragment = graphql(`
//   fragment SuccessfulSubstitution on SuccessfulSubstitutionGraphqlDto {
//     classRoomId
//     startDateUtc
//     endDateUtc
//     originalTeacher {
//       ...SwappedTeacherInfo
//     }
//     newTeacher {
//       ...SwappedTeacherInfo
//     }
//   }
// `);
//
// export const FailedSubstitutionFragment = graphql(`
//   fragment FailedSubstitution on FailedSubstitutionGraphqlDto {
//     classRoomId
//     startDateUtc
//     endDateUtc
//     reason
//     teacher {
//       ...SwappedTeacherInfo
//     }
//   }
// `);

export const TeacherSubstitutionResultFragment = graphql(`
  fragment TeacherSubstitutionResult on TeacherSubstitutionResultGraphqlDto {
    successfulSubstitutions {
      classRoomId
      isOnboardingLive
      startDateUtc
      endDateUtc
      originalTeacher {
        id
        email
        givenName
        familyName
        lesson1on1
      }
      newTeacher {
        id
        email
        givenName
        familyName
        lesson1on1
      }
    }
    failedSubstitutions {
      classRoomId
      startDateUtc
      endDateUtc
      reason
      teacher {
        id
        email
        givenName
        familyName
        lesson1on1
      }
    }
  }
`);
